<template>
  <div>
    <div v-if="listOfTrustee.length === 1">
      <p class="font-bold text-center text-lg">RESOLUTION</p>
    </div>
    <div v-else-if="listOfTrustee.length > 1">
      <p class="font-bold text-center text-lg">MINUTES OF A MEETING</p>
    </div>

    <p class="font-bold text-center" v-if="trusteeType.toLowerCase() === 'corporate'">
      {{ fund.trustee.company.name | uppercase }} (THE 'TRUSTEE')
    </p>
    <p class="font-bold text-center" v-else>
      {{ formatTrusteesAsString | uppercase }} (THE 'TRUSTEE')
    </p>

    <p class="font-bold text-center">AS TRUSTEE OF</p>
    <p class="font-bold text-center">{{ fundName | uppercase }} (THE ‘FUND’)</p>

    <div v-if="listOfTrustee.length > 1" class="px-0 pt-8">
      <table class="table-auto w-full leading-normal">
        <tbody>
          <tr>
            <td class="w-1/4 font-bold align-top">
              <p>PRESENT: </p>
            </td>
            <td class="text-left px-2 mt-4">
              <div v-for="(trustee, idx) in formatTrusteesAsList" :key="idx">
                {{ trustee }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- eslint-disable max-len -->
    <div class="px-0 py-8">
      <table class="table-auto w-full leading-normal">
        <tbody>
          <tr v-if="trusteeType.toLowerCase() === 'corporate' && listOfTrustee.length > 1">
            <td class="w-1/4 font-bold align-top">
              <p>
                Notice of meeting
              </p>
            </td>
            <td class="text-left px-2 mt-4 align-top font-normal">
              <p class="mb-4">
                It was noted that notice of this meeting had been provided to each director in the required manner.
              </p>
            </td>
          </tr>

          <tr>
            <td class="w-1/4 font-bold align-top">
              Request from {{ memberList.join(" ") }} regarding benefit payments
            </td>
            <td class="text-left px-2 mt-4 align-top font-normal">
              <div>
                <p v-if="ratify === 'FULLYPROSPECTIVE'">
                  A notice from {{ memberList.join(" ") }} regarding the treatment of all payments drawn from the Fund during the {{ finYear }} financial year was tabled.
                </p>
                <p v-else-if="ratify === 'FULLYRRATIFYING'">
                  It was noted that the trustee has previously agreed to certain requests from {{ memberList.join(" ") }} regarding the treatment of payments drawn from the Fund during the {{ finYear }} financial year.
                </p>
                <p v-else>
                  A notice from {{ memberList.join(" ") }} regarding the treatment of all payments drawn from the Fund during the {{ finYear }} financial year after the date of that notice was tabled.
                </p>
                <p class="mt-4">
                  It was noted that the trustee had been requested to ensure payments were drawn from specific member accounts, in a specific form (lump sums or pension payments as applicable) and priority order.
                </p>
                <p class="mt-4">
                  It was resolved that this request (as summarised in the attached schedule) would be accommodated to the extent permitted by superannuation law.
                </p>
                <p class="mt-4">
                  For the sake of clarity, it was noted that payments would only be drawn from the member's accumulation account to the extent that these were classified as “unrestricted non-preserved” amounts in accordance with the Superannuation Industry (Supervision) Regulations 1994.
                </p>
                <p class="mt-4 mb-4">
                  It was noted that the Fund's trust deed permitted payments of this nature to be made from the member's accounts in the Fund.
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td class="w-1/4 font-bold align-top">Future changes</td>
            <td class="text-left px-2 mt-4 align-top font-normal">
              <div>
                <p class="mb-4">
                  It was noted that the member may change this instruction for an individual payment or all subsequent payments at any time by notifying the Trustee.  In the absence of such a change, it was resolved that the notice would, where applicable, be treated as a valid request to partially commute the relevant pension(s).
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td class="w-1/4 font-bold align-top">Documentation</td>
            <td class="text-left px-2 mt-4 align-top font-normal">
              <div>
                <p class="">
                  It was resolved that the Fund's administrator would be authorised and instructed to prepare any documentation required by the Australian Taxation Office in relation to these payments.
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="break-inside: avoid;">
        <table class="text-left mt-8 font-normal">
          <tbody>
            <tr>
              <td>
                <div v-if="listOfTrustee.length > 1" class="mb-4">
                  <p>
                    There being no further business, the meeting closed.
                  </p>
                </div>
                <p>
                  Signed as a true and correct record.
                </p>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="px-0 mt-24 leading-normal font-normal">
          <table class="table-auto w-full">
            <tbody>
              <tr class="w-full">
                <td class="w-2/12">__________________________________</td>
                <td class="text-right"></td>
                <td class="text-right"><span v-if="listOfTrustee.length > 1">__________________________________</span></td>
              </tr>
              <tr>
                <td>
                  <p v-if="trusteeType.toLowerCase() === 'individual'">
                    Trustee
                  </p>
                  <p v-else>
                    Director
                  </p>
                </td>
                <td></td>
                <td class="text-left w-2/12"><span v-if="listOfTrustee.length > 1">Date of Meeting</span></td>
              </tr>
              <tr>
                <td class="py-8"></td>
              </tr>
              <tr>
                <td class="text-left">__________________________________</td>
                <td></td>
                <td class="px-2"></td>
              </tr>
              <tr>
                <td>Date Signed</td>
                <td></td>
                <td class="px-2"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pensionInstructionMixin } from '@/app/mixins/toolkit/pension-instructions/instruction';
import { percent } from '@/app/filters/filters';

export default {
  name: 'minutes',
  mixins: [pensionInstructionMixin],
  computed: {
    listOfTrustee() {
      return this.fund.trustee.trustees;
    },
    formatTrusteesAsString() {
      return (this.fund.trustee.trustees.flatMap(trustee => `${trustee.firstName} ${trustee.lastName}`)).join(', ');
    },
    formatTrusteesAsList() {
      return (this.fund.trustee.trustees.flatMap(trustee => `${trustee.firstName} ${trustee.lastName}`));
    },
    formatMembers() {
      return (this.fund.members.flatMap(member => `${member.firstName} ${member.lastName}`)).join(', ');
    },
    memberList() {
      return this.members.flatMap((member, idx) => (idx > 0 ? `and ${member.name}` : member.name));
    },
    rules() {
      const { rules } = this.getItem;
      return rules;
    },
  },
  methods: {
    isComputedRule(rule) {
      return (typeof rule !== 'string');
    },
    processRule(rule) {
      if (this.isComputedRule(rule)) {
        return this.processedPDF(rule);
      }
      return rule;
    },
    accounts(rule) {
      const output = [];

      rule.accounts.ruleAccounts.forEach((account) => {
        let row = '';
        if (rule.extra.type === 'percentage') {
          row = `<span class="font-bold">${account.value}%</span> - `;
        }
        row += `${account.member.name} / ${account.label} / ${account.identifier} / ${percent(account.taxFree)} tax free`;
        output.push(row);
      });
      return output;
    },
  },
};

</script>
